import { render } from "./CustomerDashboard.vue?vue&type=template&id=f890fda8&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"

import "./CustomerDashboard.vue?vue&type=style&index=0&id=f890fda8&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f890fda8"]])

export default __exports__